"use strict";

exports.__esModule = true;
exports.default = void 0;

var _lodash = _interopRequireDefault(require("lodash.chunk"));

var _range = _interopRequireDefault(require("../../../../utils/range"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getYearRangeChunks = function getYearRangeChunks(startYear, endYear, chunkSize) {
  var years = (0, _range.default)(startYear, endYear);
  var yearItemsToShow = chunkSize ? (0, _lodash.default)(years, chunkSize) : [years];
  return yearItemsToShow;
};

var _default = getYearRangeChunks;
exports.default = _default;